import { PromoBanner } from './models';
import { List } from 'immutable';
import { ITriggerPostPurchaseSurvey } from '../settings-data/settings-data.actions';
import { TrackingScreenNamesEnum } from '../tracking/tracking.data';
import { Task } from './models/task.model';
import { IErrorPayload } from '../entity-data/entity-data.actions';
import { TaskItemStateEnum } from './home-data.data';
import { ReportExpandedViewTypesEnum } from '../report-data/report-data.data';

// action enums
export enum ActionsEnum {
  LOAD_PROMO_BANNERS = 'LOAD_PROMO_BANNERS',
  SET_PROMO_BANNERS = 'SET_PROMO_BANNERS',
  POP_CURRENT_PROMO_BANNER = 'POP_CURRENT_PROMO_BANNER',
  TRIGGER_POST_PURCHASE_SURVEY = 'TRIGGER_POST_PURCHASE_SURVEY',
  DISMISS_POST_PURCHASE_SURVEY = 'DISMISS_POST_PURCHASE_SURVEY',
  FETCH_TASK = 'FETCH_TASK',
  FETCH_TASK_V4 = 'FETCH_TASK_V4',
  FETCH_TASK_ERROR = 'FETCH_TASK_ERROR',
  SET_TASK = 'SET_TASK',
  SET_TASK_ITEM_STATE = 'SET_TASK_ITEM_STATE',
  SET_TASK_ITEM_STATE_SUCCESS = 'SET_TASK_ITEM_STATE_SUCCESS',
  SET_TASK_ITEM_STATE_ERROR = 'SET_TASK_ITEM_STATE_ERROR',
  SET_TASK_COMPLETION = 'SET_TASK_COMPLETION',
  SET_TASK_COMPLETION_ERROR = 'SET_TASK_COMPLETION_ERROR',
  HANDLE_INSIGHTS_HUB_DEEPLINK = 'HANDLE_INSIGHTS_HUB_DEEPLINK',
}

// action interfaces
export interface ISetPromoBanners {
  promoBanners: List<PromoBanner>;
}

// action payloads
export interface LoadPromoBanners {
  type: ActionsEnum.LOAD_PROMO_BANNERS;
}

export interface SetPromoBanners {
  type: ActionsEnum.SET_PROMO_BANNERS;
  payload: ISetPromoBanners;
}

export interface PopCurrentPromoBanner {
  type: ActionsEnum.POP_CURRENT_PROMO_BANNER;
}

export interface TriggerPostPurchaseSurvey {
  type: ActionsEnum.TRIGGER_POST_PURCHASE_SURVEY;
  payload: ITriggerPostPurchaseSurvey;
}

export interface DismissPostPurchaseSurvey {
  type: ActionsEnum.DISMISS_POST_PURCHASE_SURVEY;
}

// -- TASK
export interface FetchTask {
  type: ActionsEnum.FETCH_TASK;
}
export interface FetchTaskV4 {
  type: ActionsEnum.FETCH_TASK_V4;
}

export interface FetchTaskError {
  type: ActionsEnum.FETCH_TASK_ERROR;
  payload: IErrorPayload;
}

export interface SetTask {
  type: ActionsEnum.SET_TASK;
  payload: {
    task: Task;
  };
}

export interface SetTaskItemState {
  type: ActionsEnum.SET_TASK_ITEM_STATE;
  payload: ITaskItemStatePayload;
}

export interface SetTaskItemStateSuccess {
  type: ActionsEnum.SET_TASK_ITEM_STATE_SUCCESS;
}

export interface SetTaskItemStateError {
  type: ActionsEnum.SET_TASK_ITEM_STATE_ERROR;
  payload: IErrorPayload;
}

export interface SetTaskCompletion {
  type: ActionsEnum.SET_TASK_COMPLETION;
}

export interface SetTaskCompletionError {
  type: ActionsEnum.SET_TASK_COMPLETION_ERROR;
  payload: IErrorPayload;
}

export interface ITaskItemStatePayload {
  id: string;
  state: TaskItemStateEnum;
}

// Insights hub

export interface IHandleInsightsHubDeeplinkPayload {
  deeplink: string;
  reportType: ReportExpandedViewTypesEnum;
  trackingScreenName: TrackingScreenNamesEnum;
}

export interface IHandleInsightsHubDeeplink {
  type: ActionsEnum.HANDLE_INSIGHTS_HUB_DEEPLINK;
  payload: IHandleInsightsHubDeeplinkPayload;
}

// action creators
export const loadPromoBanners = (): LoadPromoBanners => ({
  type: ActionsEnum.LOAD_PROMO_BANNERS,
});

export const setPromoBanners = (
  promoBanners: List<PromoBanner>
): SetPromoBanners => ({
  type: ActionsEnum.SET_PROMO_BANNERS,
  payload: {
    promoBanners,
  },
});

export const popCurrentPromoBanner = (): PopCurrentPromoBanner => ({
  type: ActionsEnum.POP_CURRENT_PROMO_BANNER,
});

export const triggerPostPurchaseSurvey = (
  title: string,
  header: string,
  trackingScreenName: TrackingScreenNamesEnum
): TriggerPostPurchaseSurvey => ({
  type: ActionsEnum.TRIGGER_POST_PURCHASE_SURVEY,
  payload: {
    title,
    header,
    trackingScreenName,
  },
});

export const dismissPostPurchaseSurvey = (): DismissPostPurchaseSurvey => ({
  type: ActionsEnum.DISMISS_POST_PURCHASE_SURVEY,
});

// == Task
export const fetchTask = (): FetchTask => ({
  type: ActionsEnum.FETCH_TASK,
});
export const fetchTaskV4 = (): FetchTaskV4 => ({
  type: ActionsEnum.FETCH_TASK_V4,
});

export const fetchTaskError = (error: Error, data: any[]): FetchTaskError => ({
  type: ActionsEnum.FETCH_TASK_ERROR,
  payload: {
    error,
    data,
  },
});

export const setTask = (task: Task): SetTask => ({
  type: ActionsEnum.SET_TASK,
  payload: {
    task,
  },
});

export const setTaskItemState = (
  id: string,
  state: TaskItemStateEnum
): SetTaskItemState => ({
  type: ActionsEnum.SET_TASK_ITEM_STATE,
  payload: {
    id,
    state,
  },
});

export const setTaskItemStateSuccess = (): SetTaskItemStateSuccess => ({
  type: ActionsEnum.SET_TASK_ITEM_STATE_SUCCESS,
});

export const setTaskItemStateError = (
  error: Error,
  data: any[]
): SetTaskItemStateError => ({
  type: ActionsEnum.SET_TASK_ITEM_STATE_ERROR,
  payload: {
    error,
    data,
  },
});

export const setTaskCompletion = (): SetTaskCompletion => ({
  type: ActionsEnum.SET_TASK_COMPLETION,
});

export const setTaskCompletionError = (
  error: Error,
  data: any[]
): SetTaskCompletionError => ({
  type: ActionsEnum.SET_TASK_COMPLETION_ERROR,
  payload: {
    error,
    data,
  },
});

export const handleInsightsHubDeeplink = (
  deeplink: string,
  reportType: ReportExpandedViewTypesEnum,
  trackingScreenName: TrackingScreenNamesEnum
): IHandleInsightsHubDeeplink => ({
  type: ActionsEnum.HANDLE_INSIGHTS_HUB_DEEPLINK,
  payload: {
    deeplink,
    reportType,
    trackingScreenName,
  },
});
